module.exports = __webpack_public_path__ + "static/class-plus-c1edcd41ac12aac3b5e0b1ecf63176a1.jpg";